export const INIT_STORAGE_FAVORITES = 'INIT_STORAGE_FAVORITES'
export const ADD_FAVORITE_COLLECTION = 'ADD_FAVORITE_COLLECTION'
export const DELETE_FAVORITE_COLLECTION = 'DELETE_FAVORITE_COLLECTION'

export const ADD_FAVORITE_DESIGN = 'ADD_FAVORITE_DESIGN'
export const DELETE_FAVORITE_DESIGN = 'DELETE_FAVORITE_DESIGN'
export const DELETE_GROUP_DESIGNS = 'DELETE_GROUP_DESIGNS'


